// extracted by mini-css-extract-plugin
export default {"basicMultiSelect":"MovilTabSelector_basicMultiSelect__Tb0jj"};